var map = {
	"./KECC/AboutUs/AboutESG/lang/zh-tw.json": "./src/components/DefaultHome/KECC/AboutUs/AboutESG/lang/zh-tw.json",
	"./KECC/AboutUs/AboutKEC/lang/zh-tw.json": "./src/components/DefaultHome/KECC/AboutUs/AboutKEC/lang/zh-tw.json",
	"./KECC/AboutUs/ContactUs/lang/zh-tw.json": "./src/components/DefaultHome/KECC/AboutUs/ContactUs/lang/zh-tw.json",
	"./KECC/AboutUs/JoinUs/lang/zh-tw.json": "./src/components/DefaultHome/KECC/AboutUs/JoinUs/lang/zh-tw.json",
	"./KECC/AboutUs/Team/lang/zh-tw.json": "./src/components/DefaultHome/KECC/AboutUs/Team/lang/zh-tw.json",
	"./KECC/Common/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Common/lang/zh-tw.json",
	"./KECC/Declare/Privacy/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Declare/Privacy/lang/zh-tw.json",
	"./KECC/Declare/Terms/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Declare/Terms/lang/zh-tw.json",
	"./KECC/Home/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Home/lang/zh-tw.json",
	"./KECC/Organizers/Album/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Organizers/Album/lang/zh-tw.json",
	"./KECC/Organizers/AlbumPhoto/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Organizers/AlbumPhoto/lang/zh-tw.json",
	"./KECC/Organizers/Exhibition/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Organizers/Exhibition/lang/zh-tw.json",
	"./KECC/Organizers/Facility/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Organizers/Facility/lang/zh-tw.json",
	"./KECC/Organizers/RentalVenue/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Organizers/RentalVenue/lang/zh-tw.json",
	"./KECC/Organizers/RentalVenueSpace/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Organizers/RentalVenueSpace/lang/zh-tw.json",
	"./KECC/Press/Document/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Press/Document/lang/zh-tw.json",
	"./KECC/Press/News/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Press/News/lang/zh-tw.json",
	"./KECC/Press/Video/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Press/Video/lang/zh-tw.json",
	"./KECC/Visitors/Accommodation/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Visitors/Accommodation/lang/zh-tw.json",
	"./KECC/Visitors/ExhibitionPage/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Visitors/ExhibitionPage/lang/zh-tw.json",
	"./KECC/Visitors/Traffic/lang/zh-tw.json": "./src/components/DefaultHome/KECC/Visitors/Traffic/lang/zh-tw.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/DefaultHome sync recursive ^\\.\\/KECC.*\\/lang\\/zh\\-tw\\.json$";